import React from 'react';

interface EyebrowProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: 'default' | 'accent' | 'spark' | 'success';
  withDot?: boolean;
}

const Eyebrow: React.FC<EyebrowProps> = ({
  tone = 'default',
  withDot,
  style,
  children,
  ...rest
}) => {
  const colorMap: Record<NonNullable<EyebrowProps['tone']>, string> = {
    default: 'var(--fg-3)',
    accent:  'var(--accent)',
    spark:   'var(--accent-2-soft-fg)',
    success: 'var(--success)',
  };
  const base: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: colorMap[tone],
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontFamily: 'var(--font-sans)',
    ...style,
  };
  return (
    <div style={base} {...rest}>
      {withDot && (
        <span
          style={{
            width: 6, height: 6, borderRadius: '50%',
            background: colorMap[tone],
            animation: 'cgPulse 1.6s ease-in-out infinite',
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </div>
  );
};

export default Eyebrow;
